import { gql } from '@apollo/client';

export const CART_SCHEMA = `
accessories {
      amountVatExcluded {
        discountedOneOffAmount
        discountedUpFrontAmount
        oneOffAmount
        upFrontAmount
      }
      amountVatIncluded {
        discountedOneOffAmount
        discountedUpFrontAmount
        oneOffAmount
        upFrontAmount
      }
      catalogCode
      description
      id
      serviceDomains {
        code
        displayOrder
        name
      }
    }
    accountId
    acquisitionType
    uuid
    journeyType
    reference
    creditScore
    agreedTermsAndConditions
    channelGroup
    numberAdditionalAllowedOffers {
      number
      serviceGroup
    }
    additionalAllowedOffers {
      number
      serviceGroup
    }
    offers {
      activationAt
      applyDeposit
      depositAmountVatExcluded
      depositAmountVatIncluded
      depositTerm
      directoryPreference
      id
      installationAddressId
      parentOfferId
      parentSubscriptionId
      topUpAmount
      simCard {
        iccid
        imsi
        msisdn
        catalogCode
      }
      portInInfo {
        msisdn
        portInReference
        portStartDateTime
      }
      inclusiveEquipments {
        catalogCode
        inclusiveEquipmentCatalogCode
        color
        colorCode
        description
        inventoryCode
        main
        manufacturer
        model
        type
      }
      equipments {
        capacity
        catalogCode
        color
        colorCode
        description
        id
        imei
        inventoryCode
        manufacturer
        model
        type
        charge {
          catalogCode
          pricePlan {
            amountVatExcluded
            amountVatIncluded
            catalogCode
          }
        }
        availableAt
        colorName
        discontinuedAt
        preOrderAt
        suspended
        addon {
          catalogCode
          description
          displayOrder
          id
          itemGroup
          max
          displayName
        }
        addOn {
          catalogCode
          description
          displayOrder
          id
          itemGroup
          max
          displayName
        }
      }
      discounts {
        billingType
        code
        description
        discountItemType
        value
        vatExcludedAmount
        amountVatIncluded
        billingTypeAsString
        catalogCode
        frequency
        id
        occurrence
        reason
        type
        activatedAt
        createdAt
        terminatedAt
        updatedAt
      }
      baseOffer {
        catalogCode
        catalogTariffPlanCode
        comment
        commitmentDuration
        description
        displayOrder
        portIn
        portInType
        serviceGroup
        serviceDomains
        simOnly
        tariffPlanDescription
        usages {
          displayOrder
          description
          catalogCode
          type
        }
        tariffPlanDiscount {
          amountVatExcluded
          amountVatIncluded
          description
          billingType
          catalogCode
          occurrence
        }
        tariffPlanDiscounts {
          amountVatExcluded
          amountVatIncluded
          description
          billingType
          catalogCode
          occurrence
        }
        charges {
          priceVatIncluded
          priceVatExcluded
          billingType
          activatedAt
          terminatedAt
          catalogChargeCode
          catalogPricePlanCode
          defaultPriceVatIncluded
          description
          catalogCode
          advanceArrears
          coolingOffPeriod
          createdAt
          id
          networkElements {
            activatedAt
            attributes {
              name
              value
              sortOrder
              createdAt
              id
              updatedAt
            }
            catalogCode
            createdAt
            id
            terminatedAt
            updatedAt
          }
          orderId
          price
          pricePlanCatalogCode
          updatedAt
        }
        broadbandTechnology
        minDownloadSpeed
        minUploadSpeed
      }
      appointment {
        at
        time
        type
      }
      addOns {
        catalogCode
        description
        displayOrder
        id
        itemGroup
        max
        displayName
        serviceDomain {
          code
          displayOrder
          name
        }
      }
      activationFeeVatIncluded {
        discountedOneOffAmount
        discountedUpFrontAmount
        oneOffAmount
        upFrontAmount
      }
      activationFeeVatExcluded {
        discountedOneOffAmount
        discountedUpFrontAmount
        oneOffAmount
        upFrontAmount
      }
      modemCompatible
      prequal {
        reference
        prequalId
        onlinePrequalId
        error
        addressResponse {
          addressLine1
          addressLine2
          addressLine3
          county
          eirCode
          town
        }
        ardId
        services {
          broadbandTechnology
          maxSpeed
          networkTechnology
          serviceDate
        }
        billingSource
        customerType
        validationType
        phoneNumber
      }
    }
    amountVatIncluded {
      discountedOneOffAmount
      discountedUpFrontAmount
      oneOffAmount
      upFrontAmount
      recurringAmount {
        amount
        discountFrequency
        discountOccurrence
        discountedAmount
      }
    }
    recurringAmountsByOccurrence {
      amountVatIncluded
      amountVatExcluded
      occurrence
    }
    deliveryRequired
    activationDateRequired
    brand
    channel
    customerType
    offerType
    status
    valid
    waiveEarlyCeaseCharge {
      approver
      reason
    }
    earlyCeaseCharge {
      capped
      dailyRates {
        amountVatExcluded
        amountVatIncluded
        dailyRateVatExcluded
        dailyRateVatIncluded
        days
        from
        monthlyChargeVatExcluded
        monthlyChargeVatIncluded
        to
      }
      subscriptionId
      totalAmountVatExcluded
      totalAmountVatIncluded
      totalDays
    }
    amountVatExcluded {
      discountedOneOffAmount
      discountedUpFrontAmount
      oneOffAmount
      upFrontAmount
    }
`;

const QUERIES = {
  GET_SIM_TYPES: gql`
    query getSIMTypes {
      getSIMTypes
    }
  `,
  GET_ESIM_MANUFACTURERS: gql`
    query getESIMManufacturers($cartType: CartType!) {
      getESIMManufacturers(cartType: $cartType)
    }
  `,
  GET_CURRENT_SIM_CODE: gql`
    query getCurrentSIMCode($subscriptionId: Int!) {
      getCurrentSIMCode(subscriptionId: $subscriptionId)
    }
  `,
  GET_CODE_FOR_SIMTYPE: gql`
    query getCodeForSimType($simCardType: String!, $catalogOfferCode: String!) {
      getCodeForSimType(simCardType: $simCardType, catalogOfferCode: $catalogOfferCode)
    }
  `,
};
const MUTATIONS = {
  UPDATE_SIM_TYPE: gql`
    mutation UpdateSIMType($cartType: CartType!, $reference: String!, $offerId: Int!, $simCardType: String!, $offerCode: String) {
  updateSIMType(cartType: $cartType, reference: $reference, offerId: $offerId, simCardType: $simCardType, offerCode: $offerCode) {
     ${CART_SCHEMA}
      }
    }
  `,
  UPDATE_ESIM_DETAILS: gql`
    mutation UpdateESIMDetails(
      $cartType: CartType!
      $reference: String!
      $offerId: Int!
      $eid: String!
      $manufacturer: String!
    ) {
      updateESIMDetails(
        cartType: $cartType
        reference: $reference
        offerId: $offerId
        eid: $eid
        manufacturer: $manufacturer
      ) {
        id
        reference
        offerId
        eid
        manufacturer
        type
        email
      }
    }
  `,
};
export const getSimTypes = async ({ graphql }) => {
  try {
    const { data, error } = await graphql.query({ query: QUERIES.GET_SIM_TYPES });
    return { data, error };
  } catch (error) {
    console.error('Error fetching SIM types:', error);
    return { error };
  }
};
export const updateSimType = async ({ graphql, variables = {} }) => {
  try {
    const { data, error } = await graphql.mutate({
      mutation: MUTATIONS.UPDATE_SIM_TYPE,
      variables,
    });
    return { data, error };
  } catch (error) {
    console.error('Error while updating sim type:', error);
    return null;
  }
};
export const getESIMManufacturers = async ({ graphql, variables = {} }) => {
  try {
    const { data, error } = await graphql.query({
      query: QUERIES.GET_ESIM_MANUFACTURERS,
      variables,
    });
    return { data, error };
  } catch (error) {
    console.error('Error fetching SIM Manufactures:', error);
    return { error };
  }
};
export const getCurrentSIMCode = async ({ graphql, variables = {} }) => {
  try {
    const { data, error } = await graphql.query({
      query: QUERIES.GET_CURRENT_SIM_CODE,
      variables,
    });
    return { data, error };
  } catch (error) {
    console.error('Error fetching current SIM:', error);
    return { error };
  }
};
export const getCodeForSIM = async ({ graphql, variables = {} }) => {
  try {
    const { data, error } = await graphql.query({
      query: QUERIES.GET_CODE_FOR_SIMTYPE,
      variables,
    });
    return { data, error };
  } catch (error) {
    console.error('Error fetching code for SIMType', error);
    return { error };
  }
};
export const updateESIMDetails = async ({ graphql, variables = {} }) => {
  try {
    const { data, error } = await graphql.mutate({
      mutation: MUTATIONS.UPDATE_ESIM_DETAILS,
      variables,
    });

    return { data, error };
  } catch (error) {
    console.error('Error while updating sim details:', error);
    return { error };
  }
};
